import { render } from "./case.vue?vue&type=template&id=216f6bca&scoped=true&ts=true"
import script from "./case.vue?vue&type=script&lang=ts"
export * from "./case.vue?vue&type=script&lang=ts"

import "./case.vue?vue&type=style&index=0&id=216f6bca&scoped=true&lang=less"

import exportComponent from "/root/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216f6bca"]])

export default __exports__